import Login from './Login.json';
import Main from './Main.json';
import PublisherStub from './PublisherStub.json';
import Registration from './Registration.json';
import Validation from './Validation.json';

export const en = {
    Login,
    Registration,
    Main,
    Validation,
    PublisherStub,
};
